import app from '../../common/app';
import dayjs from 'dayjs';
import extractText from './extractText';
import diffTime from '../../common/utils/diffTime';

/**
 * The `humanTime` utility converts a date to a localized, human-readable time-
 * ago string.
 */
export default function humanTime(time: dayjs.ConfigType): string {
  let d = dayjs(time);
  const now = dayjs();

  // To prevent showing things like "in a few seconds" due to small offsets
  // between client and server time, we always reset future dates to the
  // current time. This will result in "just now" being shown instead.
  if (d.isAfter(now)) {
    d = now;
  }

  const day = 864e5;
  const diff = now.diff(d);
  const {dayDiff, monthDiff} = diffTime(time);
  let ago: string;

  // If this date was more than a month ago, we'll show the name of the month
  // in the string. If it wasn't this year, we'll show the year as well.
  // 系统默认的30天
  // if (diff > 30 * day) {
  //   if (d.year() === dayjs().year()) {
  //     ago = d.format(extractText(app.translator.trans('core.lib.datetime_formats.humanTimeShort')));
  //   } else {
  //     ago = d.format(extractText(app.translator.trans('core.lib.datetime_formats.humanTimeLong')));
  //   }
  // } else {
  //   ago = d.fromNow();
  // }


  if (monthDiff) {
    ago = d.format('M-DD H:mm'); // 一个月内且是当月
  } else if(dayDiff) {
    ago = d.fromNow(); // 一天内
  } else {
    ago = d.format('YYYY-MM-DD');
  }

  return ago;
}
